import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import Home from './pages/home';
import OurBrands from './pages/careers/ourbrands'
import Careers from './pages/careers'
import TermsOfUse from './pages/termsofuse';
import OurHistory from './pages/our-company/our-history'
import StrategyMissionValues from './pages/our-company/strategy-mission-values';
import Leadership from './pages/our-company/leadership'
import CorporateResponsibilityOverview from './pages/corporate-responsibility-group'
import CorporateResponsibilityImpact from './pages/corporate-responsibility-group/impact'
import GlobalCulture from './pages/our-company/global-culture'
import SupplyChain from './pages/corporate-responsibility-group/responsible-practices/supplychain';
import LeveragingInnovation from './pages/corporate-responsibility-group/responsible-practices/leveraginginnovation';
import OurRegions from './pages/careers/regions-group';
import Distribution from './pages/careers/distribution';
import China from './pages/careers/china';
import Wellbeing from './pages/our-company/wellbeing-benefits';
import ElevatingResponsibilty from './pages/corporate-responsibility-group/responsible-practices/elevatingresponsibility';
import CleanWater from './pages/corporate-responsibility-group/stories/cleandrinkingwater';
import TransitionProjects from './pages/corporate-responsibility-group/stories/transition-projects';
import CollegiateOutdoor from './pages/corporate-responsibility-group/stories/collegiateoutdoorprogram';
import Club1938 from './pages/corporate-responsibility-group/stories/club1938';
import RepairMountainHardwear from './pages/corporate-responsibility-group/stories/repairatmountainhardwear';
import Pfas from './pages/corporate-responsibility-group/responsible-practices/pfas';
import EuropeTabPanel from './pages/careers/regions-group/europetabpanel';
import AsiaTabPanel from './pages/careers/regions-group/asiatabpanel';
import NATabPanel from './pages/careers/regions-group/natabpanel';
import ColumbiaTabPanel from './pages/careers/ourbrands/columbiatabpanel';
import MhwTabPanel from './pages/careers/ourbrands/mhwtabpanel';
import SorelTabPanel from './pages/careers/ourbrands/soreltabpanel';
import PranaTabPanel from './pages/careers/ourbrands/pranatabpanel';
import OverviewTabPanel from './pages/corporate-responsibility-group/overviewtabpanel';
import EmpoweringPeopleTab from './pages/corporate-responsibility-group/empoweringpeopletabpanel';
import SustainingPlacesTabPanel from './pages/corporate-responsibility-group/sustainingplacestabpanel';
import ResponsiblePractices from './pages/corporate-responsibility-group/responsiblepracticestabpanel';
import Highlights from './pages/corporate-responsibility-group/highlightstabpanel';
import TwentyTwentyFourImpactReport from './pages/corporate-responsibility-group/impact-reports/2024-impact-report';
import TwentyTwentyFourImpactReportAppendices from './pages/corporate-responsibility-group/impact-reports/2024-impact-report/appendices';
import TwentyTwentyFourImpactReportEmpowringPeople from './pages/corporate-responsibility-group/impact-reports/2024-impact-report/empowering-people';
import TwentyTwentyFourImpactReportSustainingPlaces from './pages/corporate-responsibility-group/impact-reports/2024-impact-report/sustaining-places';
import TwentyTwentyFourImpactReportResponsiblePractices from './pages/corporate-responsibility-group/impact-reports/2024-impact-report/responsible-practices';
import Privacy from './pages/privacy';
import Cookies from './pages/cookies';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/careers',
    element: <Careers />
  },
  {
    path: '/careers/our-brands-group',
    element: <OurBrands />
  },
  {
    path: '/careers/our-brands/columbia-careers',
    element: <ColumbiaTabPanel />
  },
  {
    path: '/careers/our-brands/sorel-careers',
    element: <SorelTabPanel />
  },
  {
    path: '/careers/our-brands/mountain-hardwear-careers',
    element: <MhwTabPanel />
  },
  {
    path: '/careers/our-brands/prana-careers',
    element: <PranaTabPanel />
  },
  // {
  //   path: '/careers/our-brands-group/?tab-78baa3e833ecb8b09e4',
  //   element: <Navigate to='/careers/our-brands/columbia-careers' />
  // },
  {
    path: '/careers/our-brands-group/?tab-78baa3e833ecb8b09e4',
    element: <Navigate to='/careers/our-brands/columbia-careers' replace />
  },
  {
    path: '/careers/our-brands-group/?tab-9d37deaf387dfeb99f5',
    element: <Navigate to='/careers/our-brands/sorel-careers' />
  },
  {
    path: '/careers/our-brands-group/?tab-7f9133205962d06a60c',
    element: <Navigate to='/careers/our-brands/mountain-hardwear-careers' />
  },
  {
    path: '/careers/our-brands-group/?tab-05cf9eb2b0103558eb1',
    element: <Navigate to='/careers/our-brands/prana-careers' />
  },
  {
    path: '/termsofuse',
    element: <TermsOfUse />
  },
  {
    path: '/our-company/our-history',
    element: <OurHistory />
  },
  {
    path: '/our-company/strategy-mission-values',
    element: <StrategyMissionValues />
  },
  {
    path: '/our-company/leadership',
    element: <Leadership />,
  },
  {
    path: '/our-company/inclusion-diversity',
    element: <Navigate to='/our-company/global-culture' />
  },
  {
    path: '/our-company/global-culture',
    element: <GlobalCulture />
  },
  {
    path: '/careers/our-brands-group/tab/tabgroupb/sorel',
    element: <Navigate to='/careers/our-brands/sorel-careers' />
  },
  {
    path: '/corporate-responsibility/impact',
    element: <CorporateResponsibilityImpact />
  },
  {
    path: '/corporate-responsibility/impact/stories/clean-drinking-water-program',
    element: <CleanWater />
  },
  {
    path: '/corporate-responsibility/impact/stories/transition-projects',
    element: <TransitionProjects />
  },
  {
    path: '/corporate-responsibility/impact/stories/collegiate-outdoor-recreation-program',
    element: <CollegiateOutdoor />
  },
  {
    path: '/corporate-responsibility/impact/stories/club-1938',
    element: <Club1938 />
  },
  {
    path: '/corporate-responsibility/impact/stories/repair-services-at-mountain-hardwear',
    element: <RepairMountainHardwear />
  },
  {
    path: '/corporate-responsibility/overview',
    element: <OverviewTabPanel />
  },
  {
    path: '/corporate-responsibility/empowering-people',
    element: <EmpoweringPeopleTab />
  },
  {
    path: '/corporate-responsibility/sustaining-places',
    element: <SustainingPlacesTabPanel />
  },
  {
    path: '/corporate-responsibility/responsible-practices',
    element: <ResponsiblePractices />
  },
  {
    path: '/corporate-responsibility/highlights',
    element: <Highlights />
  },
  {
    path: '/corporate-responsibility-group/?tab-7924f1d2e71de065b6f=',
    element: <Navigate to='/corporate-responsibility/overview' />
  },
  {
    path: '/corporate-responsibility-group/?tab-6b450decc1cd295a70a=',
    element: <Navigate to='/corporate-responsibility/empowering-people' />
  },
  {
    path: '/corporate-responsibility-group/?tab-19017f87daea3a103ca=',
    element: <Navigate to='/corporate-responsibility/sustaining-places' />
  },
  {
    path: '/corporate-responsibility-group/?tab-b57f0800d43fff2925c=',
    element: <Navigate to='/corporate-responsibility/responsible-practices' />
  },
  {
    path: '/corporate-responsibility-group/?tab-bd5d2f27b7afd43e2d1=',
    element: <Navigate to='/corporate-responsibility/highlights' />
  },
  {
    path: '/corporate-responsibility-group',
    element: <CorporateResponsibilityOverview />
  },
  {
    path: '/corporate-responsibility-group/responsible-practices/supply-chain',
    element: <SupplyChain />
  },
  {
    path: '/corporate-responsibility-group/responsible-practices/leveraging-innovation',
    element: <LeveragingInnovation />
  },
  {
    path: '/corporate-responsibility-group/responsible-practices/elevating-responsibility',
    element: <ElevatingResponsibilty />
  },
  {
    path: '/corporate-responsibility-group/responsible-practices/pfas',
    element: <Pfas />
  },
  {
    path: '/careers/regions-group',
    element: <OurRegions />
  },
  {
    path: '/careers/regions-group/north-america',
    element: <NATabPanel />
  },
  {
    path: '/careers/regions-group/asia',
    element: <AsiaTabPanel />
  },
  {
    path: '/careers/regions-group/europe',
    element: <EuropeTabPanel />
  },
  {
    path: '/careers/distribution',
    element: <Distribution />
  },
  {
    path: '/china',
    element: <China />
  },
  {
    path: '/our-company/wellbeing-benefits/',
    element: <Wellbeing />
  },
  {
    path: '/corporate-responsibility/impact/2024',
    element: <TwentyTwentyFourImpactReport />
  },
  {
    path: '/corporate-responsibility/impact/2024/appendices',
    element: <TwentyTwentyFourImpactReportAppendices />
  },
  {
    path: '/corporate-responsibility/impact/2024/empowering-people',
    element: <TwentyTwentyFourImpactReportEmpowringPeople />
  },
  {
    path: '/corporate-responsibility/impact/2024/sustaining-places',
    element: <TwentyTwentyFourImpactReportSustainingPlaces />
  },
  {
    path: '/corporate-responsibility/impact/2024/responsible-practices',
    element: <TwentyTwentyFourImpactReportResponsiblePractices />
  },
  {
    path: '/privacy-policy',
    element: <Privacy />
  },
  {
    path: '/cookie-notice',
    element: <Cookies />
  }
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
